import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param submissionData: object
// example:
// {
//  "sound_record": <Direct upload uuid>,
//  "candidate_uuid": "9c826a26-b87f-4e82-8362-9c7ceac38a48"
// }
export function submitCandidatesRecord(
  submissionData: object
): Promise<ApiResponse> {
  return Axios.post("v1/candidates/candidate_submissions", submissionData);
}

export function showCandidate(): Promise<ApiResponse> {
  return Axios.get("v1/candidates/candidates");
}
export function createCandidate(candidateData: object): Promise<ApiResponse> {
  return Axios.post("v1/candidates/candidates", candidateData);
}
export function updateCandidateData(
  candidateData: object
): Promise<ApiResponse> {
  return Axios.put("v1/candidates/candidates", candidateData);
}
